import Grid from '@mui/material/Grid';
import { Fragment } from 'react';

import CompleteYourReservation from 'reservations/availabilities/components/CompleteYourReservation';
import { useIsSubjectToCancellationFee } from 'reservations/feePolicy/hooks';
import { CreateReservationButton } from 'reservations/form/components/CreateReservationButton';
import { DinerAuthenticationFields } from 'reservations/form/components/DinerAuthenticationFields';
import MarketingOptIn from 'reservations/form/components/MarketingOptIn';
import { RequiredPaymentCreate } from 'reservations/payments/components/RequiredPayment';

export const CreateFields = () => {
  const isSubjectToCancellationFee = useIsSubjectToCancellationFee();

  const ButtonWrapper = isSubjectToCancellationFee
    ? RequiredPaymentCreate
    : Fragment;

  return (
    <>
      <Grid item>
        <CompleteYourReservation />
      </Grid>
      <DinerAuthenticationFields />
      <Grid item sx={{ mb: '-4px' }}>
        <MarketingOptIn />
      </Grid>
      <Grid item>
        <ButtonWrapper>
          <Grid item>
            <CreateReservationButton />
          </Grid>
        </ButtonWrapper>
      </Grid>
    </>
  );
};
